( function( app ) {
  const COMPONENT = {
    init: function() {
      const $toggle = $( '.navbar-toggle' );
      const $nav = $( '#primary-nav' );

      // Move focus into the nav when the mobile menu opens
      $toggle.on( 'toggleAfter', function() {
        if ( $( window ).width() < 1024 ) {
          if ( $( this ).hasClass( 'is-open' ) ) {
            const $firstFocusable = $nav.find( 'a[href], button:not([disabled])' ).first();
            if ( $firstFocusable.length ) {
              $firstFocusable.trigger( 'focus' );
            }
          } else {
            $toggle.trigger( 'focus' );
          }
        }
      } );

      // Close mobile menu and restore focus on Escape
      $nav.on( 'keydown', function( e ) {
        if ( e.key === 'Escape' && $( window ).width() < 1024 && $toggle.hasClass( 'is-open' ) ) {
          $toggle.trigger( 'click' );
          $toggle.trigger( 'focus' );
        }
      } );

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-five .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-five', COMPONENT );
} )( app );
